import {action} from "mobx";
import appConfigService from "../services/appConfigService";
import appStore from "./appStore";
import i18n from "../i18n";

class appConfigStore {
    @action getAppConfig = async params => {
        const resultOfRequest = await appConfigService.getAppConfig(params);
        return resultOfRequest;
    };

    @action createAppConfig = async params => {
        const resultOfRequest = await appConfigService.createAppConfig(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.appConfigStore.createAppConfig.successMessageContent", {
                ns: "common"
            })
        });
        return resultOfRequest.data;
    };

    @action updateAppConfig = async params => {
        const resultOfRequest = await appConfigService.updateAppConfig(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.appConfigStore.updateAppConfig.successMessageContent", {
                ns: "common"
            })
        });
        return true;
    };
}

export default new appConfigStore();
